type ModelTier = "standard" | "enterprise"

export type AIModelSurface =
  | "regular_text_judge"
  | "composite_evaluation"
  | "rubric_decision_tree"

interface AIModelOption {
  id: string
  label: string
  provider: "Coval" | "OpenAI" | "Anthropic" | "Google"
  description?: string
  tier?: ModelTier
  supportsThinking?: boolean
  supportedSurfaces?: AIModelSurface[]
}

export const AI_MODELS: AIModelOption[] = [
  {
    id: "coval_judge",
    label: "Coval's Judge",
    provider: "Coval",
    description: "Coval's proprietary evaluator",
  },
  {
    id: "openai:gpt-4.1-mini-2025-04-14",
    label: "GPT-4.1 Mini",
    provider: "OpenAI",
    description: "Best balance of speed and quality for most use cases",
  },
  {
    id: "openai:gpt-4.1-2025-04-14",
    label: "GPT-4.1",
    provider: "OpenAI",
    description: "Maximum accuracy for complex evaluations",
  },
  {
    id: "openai:gpt-5-mini-2025-08-07",
    label: "GPT-5 Mini",
    provider: "OpenAI",
    description: "Latest OpenAI model with improved performance",
  },
  // { // disabled for now - gpt 5 nano lowkey sucks
  //   id: "openai:gpt-5-nano-2025-08-07",
  //   label: "GPT-5 Nano",
  //   provider: "OpenAI",
  //   description: "Optimized for fast response times",
  // },
  {
    id: "anthropic:claude-haiku-4-5-20251001",
    label: "Claude Haiku 4.5",
    provider: "Anthropic",
    description: "Efficient and reliable evaluations",
  },
  {
    id: "google:gemini-2.5-flash",
    label: "Gemini 2.5 Flash",
    provider: "Google",
    description: "Google's high-performance model",
  },
  {
    id: "google:gemini-2.5-flash-lite",
    label: "Gemini 2.5 Flash Lite",
    provider: "Google",
    description: "Streamlined for quick processing",
  },
  // Enterprise tier — Phase 1
  {
    id: "anthropic:claude-sonnet-4-6",
    label: "Claude Sonnet 4.6",
    provider: "Anthropic",
    description:
      "Anthropic's most capable evaluation model with optional thinking mode",
    tier: "enterprise",
    supportsThinking: true,
  },
  {
    id: "openai:gpt-5.4",
    label: "GPT-5.4",
    provider: "OpenAI",
    description:
      "OpenAI's most capable evaluation model with optional reasoning mode",
    tier: "enterprise",
    supportsThinking: true,
  },
  {
    id: "openai:gpt-6-luna",
    label: "GPT-6 Luna",
    provider: "OpenAI",
    description: "OpenAI evaluation model with optional medium reasoning mode",
    tier: "enterprise",
    supportsThinking: true,
    supportedSurfaces: ["regular_text_judge"],
  },
]
